// Add Class
// export const AddClassBase = 'configuration/add-class'
// export const addClassList = AddClassBase + '/list'
// export const addClassStore = AddClassBase + '/store'
// export const addClassShow = AddClassBase + '/show'
// export const addClassUpdate = AddClassBase + '/update'
// export const addClassStatus = AddClassBase + '/toggle-status'
// export const addClassDestroy = AddClassBase + '/destroy'

// export const SeizerListBase = 'configuration/add-class'
// export const seizerList = SeizerListBase + '/list'
// Training Instructor Profile
// export const trainerProfileListApi = 'education-management/training-instructor-profile/list'
// export const trainerProfileStoreApi = 'education-management/training-instructor-profile/store'
// export const trainerProfileUpdateApi = 'education-management/training-instructor-profile/update'
// export const trainerProfileToggleStatusApi = 'education-management/training-instructor-profile/toggle-status'
// routine management api
export const routineListApi = 'routine-management/list'
export const routineSaveApi = 'routine-management/save'
export const instructorInfoApi = 'routine-management/instructor-info'
export const routineUpdateApi = 'routine-management/update'
export const routineDetailApi = 'routine-management/details'
// demo api start
export const AddClassBase = 'configuration/add-class'
export const addClassList = AddClassBase + '/list'
export const addClassStore = AddClassBase + '/store'
export const addClassShow = AddClassBase + '/show'
export const addClassUpdate = AddClassBase + '/update'
export const addClassStatus = AddClassBase + '/toggle-status'
export const addClassDestroy = AddClassBase + '/destroy'

export const SeizerListBase = 'configuration/add-class'
export const seizerList = SeizerListBase + '/list'
// demo api end

// Training Instructor Profile
export const trainerProfileListApi = 'education-management/training-instructor-profile/list'
export const trainerProfileStoreApi = 'education-management/training-instructor-profile/store'
export const trainerProfileUpdateApi = 'education-management/training-instructor-profile/update'
export const trainerProfileToggleStatusApi = 'education-management/training-instructor-profile/toggle-status'

// Course management
export const courseManagementListApi = 'education-management/course-management/list'
export const courseManagementStoreApi = 'education-management/course-management/store'
export const courseManagementUpdateApi = 'education-management/course-management/update'
export const courseManagementToggleStatusApi = 'education-management/course-management/toggle-status'

// co-curricular activities api
export const coCurricularListApi = 'education-management/co-curricular-activities-scheduler/list'
export const coCurricularStoreApi = 'education-management/co-curricular-activities-scheduler/store'
export const coCurricularUpdateApi = 'education-management/co-curricular-activities-scheduler/update'
export const coCurricularToggleStatusApi = 'education-management/co-curricular-activities-scheduler/toggle-status'

// Exam management api
export const examManagementListApi = 'education-management/exam-management/list'
export const examManagementStoreApi = 'education-management/exam-management/store'
export const examManagementUpdateApi = 'education-management/exam-management/update'
export const examManagementToggleStatusApi = 'education-management/exam-management/toggle-status'

// Class Attendance Management
export const studentInfoApi = 'education-management/class-attendance-management/get-student-info'
export const classAttendanceListApi = 'education-management/class-attendance-management/list'
export const classAttendanceStoreApi = 'education-management/class-attendance-management/store'
export const classAttendanceUpdateApi = 'education-management/class-attendance-management/update'

// Transcript/Mark sheet Management
export const transcriptMarkListApi = 'education-management/transcript-mark-certificate/list'
export const transcriptApplyApi = 'education-management/transcript-mark-certificate/transcript-apply'
export const transcriptDocUploadApi = 'education-management/transcript-mark-certificate/transcript-upload'
